import axios from "axios"
import Vue from "vue"
import router from "@/router"
import store from "@/store"
import * as types from "./store/modules/general/mutation_types"

axios.defaults.timeout = 30000

axios.interceptors.request.use(
  (config) => {
    store.commit("general/" + types.LOADING_START)

    let token = store.getters["auth/token"] || null
    let authorized = token && token.checkValid()
    if (authorized) {
      config.headers.common["Authorization"] = "Bearer " + token.access_token
    }

    return config
  },
  (error) => {
    store.commit("general/" + types.LOADING_STOP)
    alert(error)
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  (data) => {
    store.commit("general/" + types.LOADING_STOP)

    return data
  },
  (error) => {
    store.commit("general/" + types.LOADING_STOP)

    if (
      error.response &&
      error.response.status > 400
    ) {
      let error_data = error.response.data
      if (
        error.request.responseType === "arraybuffer" &&
        error.response.data instanceof ArrayBuffer
      ) {
        error_data = JSON.parse(Buffer.from(error_data).toString("utf8"))
      }

      // console.log(error_data)      
      let msg = error_data.msg || error_data.message || error_data.error
      if(error_data.errors){
        // schema error msg
        msg = JSON.stringify(error_data.errors)
      }

      if (
        msg &&
        (msg === "Bad credentials" || msg === "Signature verification failed")
      ) {
        router.push({ name: "SignIn" })
      } 
      else if(error.response.config.url.endsWith('auth/login')){
        //因为登陆的错误处理已经在调用中弄处理，就不走下面的弹窗错误提醒逻辑
      }
      else {
        alert("接口请求错误，详情：" +msg)
        // alert("后台服务器错误:" + msg + ",  错误码:" + error.response.status)
        // Vue.prototype.$dialog.error({
        //   title: "错误码：" + error.response.status,
        //   text: "错误信息：" + msg,
        // })
      }
      return Promise.reject(error)
    } else {
      // error anyway
      return Promise.reject(error)
    }
  }
)

const Plugin = {};

Plugin.install = function (Vue) {
  Vue.axios = axios;
  window.axios = axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return axios;
      },
    },
    $axios: {
      get() {
        return axios;
      },
    },
  });
};

Vue.use(Plugin);

export default axios
